import React from 'react'
import { Link } from 'react-router-dom'

function ActivityItem({ title, count, link }) {
    
    const itemStyle = count > 0 ? 'activity-item item-hover' : 'activity-item'

    return (
        <div className={itemStyle}>
            <Link to={link}>
                <h4 className={count ? '' : 'text-secondary'}>{count}</h4>
                <p className='normal-text'>{title}</p>
            </Link>
        </div>
    )
}

export default ActivityItem